import { allTrackers } from "app/services/track/track";

import createContactsFiltersTrackingService from "./contacts-filters/trackingService";
import createFiltersPanelTrackingService from "./filters-panel/filtersPanelTrackingService";
import createQuickSearchesTrackingService from "./quick-searches/quickSearchesTrackingService";
import createSaveSearchTrackingService from "./save-search/saveSearchTrackingService";

export const createAdvancedSearchTrackingService = (
    trackEvent: (category: string, action: string, eventName: string) => void,
) => {
    const trackWithBaseCategory = (action: string, eventName: string) => {
        trackEvent("lead gen filters", action, eventName);
    };

    return {
        filtersPanel: createFiltersPanelTrackingService(trackEvent),
        quickSearches: createQuickSearchesTrackingService(trackEvent),
        saveSearch: createSaveSearchTrackingService(trackEvent),
        contactsFilters: createContactsFiltersTrackingService(trackEvent),

        trackTechnologyNotFound(query: string, eventOrigin: string) {
            trackEvent("dropdown", "search technology", `missing technology/${query}/${eventOrigin}`);
        },

        trackCreateStaticList() {
            trackEvent("account list", "create list", "account list");
        },
        trackToggleAggregatedData(isAggregatedDataUsed: boolean) {
            if (isAggregatedDataUsed) {
                trackWithBaseCategory(
                    "aggregate country data",
                    "traffic and engagement/aggregated data/list of countries",
                );
            } else {
                trackWithBaseCategory("split country data", "traffic and engagement/aggregated data/list of countries");
            }
        },

        trackCompanySelectFilterChange(companyName: string) {
            trackEvent("filters panel", "select value", `company name/contacts/${companyName}`);
        },
    };
};

export default createAdvancedSearchTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));
